export const parseSwapLimits = (amountsStr: string): Record<string, number> => {
  return (amountsStr || '')
    .replace(/(\n|\s|,){1,}/g, ' ')
    .split(' ')
    .filter(Boolean)
    .reduce<Record<string, number>>((acc, amountStr: string) => {
      if (Number(amountStr)) {
        return { default: Number(amountStr), ...acc };
      }
      const [currencyPair, amount] = amountStr.split(':');
      return { ...acc, [currencyPair]: Number(amount) };
    }, {});
};

export const getSwapAmountLimitByOrder = (
  swapAmountLimits: Record<string, number>,
  l1FirstToken: string,
  l1SecondToken: string
) => {
  // Get all entries from minSwapAmounts
  const entries = Object.entries(swapAmountLimits);

  // Find matching entries
  const matchingEntries = entries.filter(([key]) => {
    // Check if key matches the pattern
    return key === `${l1FirstToken}-${l1SecondToken}` || key === `${l1FirstToken}-*` || key === `*-${l1SecondToken}`;
  });

  // Sort by index (position in original entries array)
  const sortedEntries = matchingEntries.sort((a, b) => {
    const indexA = entries.findIndex(([key]) => key === a[0]);
    const indexB = entries.findIndex(([key]) => key === b[0]);
    return indexA - indexB;
  });

  // Return the value of the first matching entry (smallest index)
  return sortedEntries[0]?.[1] || swapAmountLimits.default;
};
